import { render, staticRenderFns } from "./CardValue.vue?vue&type=template&id=6c1d54c0"
import script from "./CardValue.vue?vue&type=script&lang=js"
export * from "./CardValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports